import { useSelector } from 'react-redux';
import { useQuery } from 'hooks/useCustomQuery';
import getPartnerPlans from 'API/Partner/getPartnerPlans';

const useGetPartnerPlans = (setPlans) => {
    const { currentPartner } = useSelector((state) => state.navigationLists);
    useQuery({
        queryKey: ['partnerPlans'],
        queryFn: async () => {
            try {
                const res = await getPartnerPlans(currentPartner);
                setPlans(res?.data);
                return res?.data || [];
            } catch (error) {
                console.error('Failed to fetch partner plans:', error);
                setPlans([]);
                return [];
            }
        },
        enabled: !!currentPartner,
        refetchOnWindowFocus: false,
        staleTime: 0,
    });

    return {};
};

export default useGetPartnerPlans;
